/* eslint-disable no-unused-vars */
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { IMAGE_BASE_URL } from '../config';

function CarrouselPhotos({ props }) {
  const { photos, currentPhoto } = props;
  const [currentIndex, setCurrentIndex] = useState(currentPhoto);
  const [direction, setDirection] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        handlePrevious();
      } else if (e.key === 'ArrowRight') {
        handleNext();
      }
    };

    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      touchEndX = e.changedTouches[0].clientX;
      if (touchStartX - touchEndX > 50) {
        handleNext();
      } else if (touchEndX - touchStartX > 50) {
        handlePrevious();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  const slideVariants = {
    hiddenRight: {
      opacity: 0,
    },
    hiddenLeft: {
      opacity: 0,
    },
    visible: {
      x: '0',
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
  };
  const dotsVariants = {
    initial: {
      y: 0,
    },
    animate: {
      y: -10,
      scale: 1.2,
      transition: { type: 'spring', stiffness: 1000, damping: '10' },
    },
    hover: {
      scale: 1.1,
      transition: { duration: 0.2 },
    },
  };

  const handleNext = () => {
    setDirection('right');
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 === photos.length ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setDirection('left');
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 < 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  const handleDotClick = (index) => {
    setDirection(index > currentIndex ? 'right' : 'left');
    setCurrentIndex(index);
  };

  return (
    <div className="relative z-[7000] h-full w-full m-auto flex flex-col items-center p-1 sm:p-5 rounded-lg ">
      <motion.div
        className="hidden sm:absolute text-[#fff] mx-5 my-auto top-0 bottom-0 left-0 z-[1000] h-11 w-11 cursor-pointer bg-[#767676b3] rounded-full sm:flex sm:justify-center sm:items-center hover:scale-110"
        onClick={handlePrevious}
      >
        <ArrowBackIosNewOutlinedIcon />
      </motion.div>
      <AnimatePresence mode="wait">
        <motion.img
          className="h-full w-full object-cover sm:w-fit sm:object-contain sm:rounded-lg sm:border border-white/50"
          key={currentIndex}
          src={`${IMAGE_BASE_URL}/images/spectacles/${photos[currentIndex]}`}
          initial={direction === 'right' ? 'hiddenRight' : 'hiddenLeft'}
          animate="visible"
          exit="exit"
          variants={slideVariants}
        />
      </AnimatePresence>
      <motion.div
        className="hidden sm:absolute text-[#fff] mx-5 my-auto top-0 bottom-0 right-0 z-[1000] h-11 w-11 cursor-pointer bg-[#767676b3] rounded-full sm:flex sm:justify-center sm:items-center hover:scale-110"
        onClick={handleNext}
      >
        <ArrowForwardIosOutlinedIcon />
      </motion.div>
      <div className="flex justify-center gap-5 overflowX-hidden w-full absolute bottom-5 sm:bottom-0">
        {photos.map((_, index) => (
          <motion.div
            key={index}
            className={`dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            initial="initial"
            animate={currentIndex === index ? 'animate' : ''}
            whileHover="hover"
            variants={dotsVariants}
          ></motion.div>
        ))}
      </div>
    </div>
  );
}

export default CarrouselPhotos;
